"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.AppBarIconButton = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Styling = require("@fluentui/react/lib/Styling");

var _Button = require("@fluentui/react/lib/Button");

var React = _interopRequireWildcard(require("react"));

var _AppBarIconButton = require("./AppBarIconButton.styles");

var _dec, _class;

var AppBarIconButton = (_dec = (0, _react.customizable)('AppBarIconButton', ['theme', 'style'], true), _dec(_class = /*#__PURE__*/function (_BaseComponent) {
  (0, _inherits2.default)(AppBarIconButton, _BaseComponent);

  var _super = (0, _createSuper2.default)(AppBarIconButton);

  function AppBarIconButton() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, AppBarIconButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this._skipComponentRefResolution = true;
    return _this;
  }
  /**
   * Tell BaseComponent to bypass resolution of componentRef.
   */


  (0, _createClass2.default)(AppBarIconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          styles = _this$props.styles,
          children = _this$props.children,
          primary = _this$props.primary;
      var theme = this.props.theme || (0, _Styling.getTheme)();
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.BaseButton, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.props), {}, {
        variantClassName: "ms-Button--appBar",
        styles: (0, _AppBarIconButton.getStyles)(theme, styles, primary),
        children: children
      }));
    }
  }]);
  return AppBarIconButton;
}(_react.BaseComponent)) || _class);
exports.AppBarIconButton = AppBarIconButton;